import React from 'react';
import styled from 'styled-components';
import { Timeline, TimelineStep } from '@tviklax/ui-components';
import { SchedulingTimelineProps } from './SchedulingContextTypes';

const TimelineWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing[6]};
  background: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  margin-bottom: ${({ theme }) => theme.spacing[8]};
  box-shadow: ${({ theme }) => theme.shadows.sm};
`;

const TimelineTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0 0 ${({ theme }) => theme.spacing[6]} 0;
`;

export const SchedulingTimeline: React.FC<SchedulingTimelineProps> = ({
  stages,
  currentStageIndex,
}) => {
  const timelineSteps: TimelineStep[] = stages.map((stage, index) => {
    let status: 'completed' | 'active' | 'pending';

    if (index < currentStageIndex) {
      status = 'completed';
    } else if (index === currentStageIndex) {
      status = 'active';
    } else {
      status = 'pending';
    }

    return {
      id: `stage-${index}`,
      label: stage.name,
      status,
      date: stage.completedAt ?? stage.startedAt,
    };
  });

  return (
    <TimelineWrapper>
      <TimelineTitle>Scheduling Timeline</TimelineTitle>
      <Timeline steps={timelineSteps} orientation="horizontal" size="md" />
    </TimelineWrapper>
  );
};
